const conditions = () => {
  return [
    { projectType: { $ne: '' } },
    { assetClass: { $ne: 'object.asset-class.options.micro-und-serviced-living' } },
    { assetClass: { $ne: 'object.asset-class.options.freies-ankaufsprofil' } },
    { assetClass: { $ne: 'object.asset-class.options.handel-retail' } },
    { assetClass: { $ne: 'object.asset-class.options.hotel' } },
    { assetClass: { $ne: 'object.asset-class.options.healthcare-medical' } },
    { assetClass: { $ne: 'object.asset-class.options.buero' } },
    { assetClass: { $ne: 'object.asset-class.options.logistik-industrie' } },
  ]
}

export default conditions
